var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('apexchart',{attrs:{"type":"heatmap","height":"350","options":_vm.chartOptions,"series":_vm.interactionTypesPerHour}})
}
var staticRenderFns = []

export { render, staticRenderFns }